import { ColumnVisibilityState } from "features/MappingEditor/types";
import { dynamicTableStore } from "../DynamicTableStore";

const COLUMN_VISIBILITY_STATE_NAME = {
  Inventory: "Inventory_columns",
  DME: "DME_columns",
  None: "None",
} as const;

export function replaceVisibilitySettings(): ColumnVisibilityState {
  /**
   * Takes existing visibility in local storage,
   * updates it with the given columns and then
   * stores it back in local storage
   */
  const savedState = retrieveSavedColumns();
  let visibleKeys: string[] = [];
  visibleKeys = getVisibleColumnKeys(savedState);
  if (!visibleKeys.length) {
    visibleKeys = dynamicTableStore.getDBSavedDefaultColumnsKeys();
  }
  const state: { [key: string]: boolean } = {};
  dynamicTableStore.dynamicColumns.forEach(
    (el) => (state[el.key_name] = false)
  );
  visibleKeys.forEach((key) => {
    // Columns that no longer exists are lost. e.g. ifc properties
    if (key in state) {
      state[key] = true;
    }
  });
  const visibleColumnsKeys = getVisibleColumnKeys(state);
  dynamicTableStore.setDefaultVisibleColumnProperties(visibleColumnsKeys);
  return state;
}

function getVisibleColumnKeys(state: ColumnVisibilityState): string[] {
  /**
   * Returns only the columns marked as visible
   */
  const visibleColumnNames = Object.entries(state)
    .map((item) => {
      if (item[1] === true) return item[0];
    })
    .filter(Boolean) as string[];
  return visibleColumnNames;
}

export function saveColumnState(state: ColumnVisibilityState) {
  /**
   * Saves the state in the local storage
   */
  localStorage.setItem(
    COLUMN_VISIBILITY_STATE_NAME[dynamicTableStore.mode],
    JSON.stringify(state)
  );
}

function retrieveSavedColumns(): ColumnVisibilityState {
  /**
   * Returns the information from the local storage
   */
  const savedState = JSON.parse(
    localStorage.getItem(
      COLUMN_VISIBILITY_STATE_NAME[dynamicTableStore.mode]
    ) ?? "{}"
  );
  return savedState;
}
